import { defineMessages } from 'react-intl';

type MessageDescriptor = {
	id: string;
	defaultMessage: string;
	description: string;
};

export const messages: {
	switchSiteLabel: MessageDescriptor;
	switchSiteHeading: MessageDescriptor;
} = defineMessages({
	switchSiteLabel: {
		id: 'twg-microsite-common.SiteSwitcher.switchSiteLabel',
		defaultMessage: 'Switch site',
		description:
			'Accessible label and tooltip for the site switcher trigger button. Here, "site" means an Atlassian cloud site, the tenant instance that a set of products and data belongs to, not a website or a physical location.',
	},
	switchSiteHeading: {
		id: 'twg-microsite-common.SiteSwitcher.switchSiteHeading',
		defaultMessage: 'Switch site',
		description:
			'Heading shown at the top of the site switcher dropdown menu. Here, "site" means an Atlassian cloud site, the tenant instance that a set of products and data belongs to, not a website or a physical location.',
	},
});
